import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const data = {
  userName: '',
  accessToken: '',
};

export default {
  namespaced: true,
  state: data,
  getters,
  mutations,
  actions,
};
